// FLAGS: consent
// Reads the Cookiebot consent object off `window` and answers whether a set of categories is
// consented to; the only cookie-consent primitive in the app.
export const getCookiebotConsent = () => {
  if (typeof window !== "undefined" && window.Cookiebot?.consent) {
    return {
      necessary: window.Cookiebot.consent.necessary,
      preferences: window.Cookiebot.consent.preferences,
      statistics: window.Cookiebot.consent.statistics,
      marketing: window.Cookiebot.consent.marketing,
    };
  }
  return null;
};

export const isCookiebotReady = (): boolean => {
  return (
    typeof window !== "undefined" &&
    window.Cookiebot !== undefined &&
    window.Cookiebot.consent !== undefined
  );
};

// FLAGS: consent
// Fails closed on its own — no Cookiebot object means false — but posthog.service.ts inverts that
// (`!isCookiebotReady() || hasConsentFor(...)`), so events are captured while the banner is still
// loading. This helper is not the enforcement; each caller decides what "not ready" means.
export const hasConsentFor = (categories: string | string[]): boolean => {
  if (!isCookiebotReady()) return false;

  const consent = getCookiebotConsent();
  if (!consent) return false;

  const cats = Array.isArray(categories) ? categories : [categories];
  return cats.every((category) => consent[category as keyof typeof consent]);
};
